<div class="media profile-media">
    <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt="">
    <div class="media-body"><span>{{ userName | titlecase }}</span>
        <p class="mb-0 font-roboto">{{ (tipo == 2 ? 'Administrador' : 'Usuario') }} <i class="middle fa fa-angle-down"></i></p>
    </div>
</div>
<ul class="profile-dropdown onhover-show-div">
    <li><a href="javascript: void(0);" (click)="changePassword()"><app-feather-icons [icon]="'lock'"></app-feather-icons><span>Cambiar Contraseña</span></a></li>
    <li><a (click)="logout()"><app-feather-icons [icon]="'log-out'"></app-feather-icons><span>Cerrar Sesión</span></a></li>
</ul>